import { DEFAULT_THEME } from 'components/Settings/Workspace/InterfaceColorSettings/InterfaceColorSettings'
import { WorkspaceColorScheme } from 'types'

export const useDefaultTheme = (): WorkspaceColorScheme => {
  return DEFAULT_THEME
}
